import { Handle, Position } from '@xyflow/react';
import { WorkflowHandlerID } from '../../workflow/ui';
import { SOURCE_HANDLE_CLASSNAME, TARGET_HANDLE_CLASSNAME } from './helpers';

const SOURCE_OFFSET = { left: '54%' };
const TARGET_OFFSET = { left: '46%' };

interface StandardHandlesProps {
  withReverseVerticals?: boolean;
  isSourceConnectable?: boolean;
}

// Auto-layout rewrites every transition to one of these four handle ids, so a node
// missing one silently stops rendering its edges once laid out in that direction.
export const StandardHandles = ({
  withReverseVerticals = false,
  isSourceConnectable,
}: StandardHandlesProps) => (
  <>
    <Handle
      type="source"
      position={Position.Right}
      className={SOURCE_HANDLE_CLASSNAME}
      id={WorkflowHandlerID.SOURCE_RIGHT}
      isConnectable={isSourceConnectable}
    />
    <Handle
      type="target"
      position={Position.Left}
      className={TARGET_HANDLE_CLASSNAME}
      id={WorkflowHandlerID.TARGET_LEFT}
    />
    <Handle
      type="source"
      position={Position.Bottom}
      className={SOURCE_HANDLE_CLASSNAME}
      id={WorkflowHandlerID.SOURCE_BOTTOM}
      style={withReverseVerticals ? SOURCE_OFFSET : undefined}
      isConnectable={isSourceConnectable}
    />
    <Handle
      type="target"
      position={Position.Top}
      className={TARGET_HANDLE_CLASSNAME}
      id={WorkflowHandlerID.TARGET_TOP}
      style={withReverseVerticals ? TARGET_OFFSET : undefined}
    />
    {withReverseVerticals && (
      <>
        <Handle
          type="source"
          position={Position.Top}
          className={SOURCE_HANDLE_CLASSNAME}
          id={WorkflowHandlerID.SOURCE_TOP}
          style={SOURCE_OFFSET}
        />
        <Handle
          type="target"
          position={Position.Bottom}
          className={TARGET_HANDLE_CLASSNAME}
          id={WorkflowHandlerID.TARGET_BOTTOM}
          style={TARGET_OFFSET}
        />
      </>
    )}
  </>
);
